import moment from 'moment-timezone';

export const DEFAULT_IANA_TIMEZONE = 'Africa/Nairobi';

const toValidIana = (value: unknown): string | null => {
  if (typeof value !== 'string') return null;
  const timezone = value.trim();
  if (!timezone) return null;
  return moment.tz.zone(timezone) ? timezone : null;
};

export const getDetectedIanaTimezone = (): string => {
  const detected = Intl?.DateTimeFormat?.().resolvedOptions?.().timeZone;
  return toValidIana(detected) ?? DEFAULT_IANA_TIMEZONE;
};

export const getUserTimezoneUpdatePatch = (
  current: unknown,
): Record<string, string> | Record<string, never> => {
  const next = getDetectedIanaTimezone();
  const currentValid = toValidIana(current);
  if (!currentValid) return { bp_user_timezone: next };
  return next === currentValid ? {} : { bp_user_timezone: next };
};

export const getLocationTimezoneUpdatePatch = (
  current: unknown,
): Record<string, string> | Record<string, never> => {
  const next = getDetectedIanaTimezone();
  const currentValid = toValidIana(current);
  if (!currentValid) return { bp_location_timezone: next };
  return next === currentValid ? {} : { bp_location_timezone: next };
};
